import { customerOperationError } from "./error-presentation.js";

// Bound the UI wait, not the server transaction. Aborting a POST would not prove
// that it was rolled back, and replaying it could repeat an already committed action.
export async function waitForStartupCreation(operation, { timeoutMs = 60000, onLateSettlement } = {}) {
  let timedOut = false;
  let timer;
  const creation = Promise.resolve().then(operation);
  const late = () => {
    if (timedOut) void Promise.resolve().then(() => onLateSettlement?.()).catch(() => {});
  };
  creation.then(late, late);
  const deadline = new Promise((_, reject) => {
    timer = globalThis.setTimeout(() => {
      timedOut = true;
      reject(customerOperationError("pirdy_startup_outcome_unknown"));
    }, timeoutMs);
  });
  try {
    return await Promise.race([creation, deadline]);
  } catch (error) {
    // A clear validation/auth rejection can be corrected. Lost responses, server
    // failures and conflicts require an account read before any new submission.
    if ([400, 401, 403, 404, 422].includes(error?.status)) throw error;
    throw customerOperationError("pirdy_startup_outcome_unknown", error);
  } finally {
    globalThis.clearTimeout(timer);
  }
}
